import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-underline-icon',
  templateUrl: './text-underline.component.html'
})
export class TextUnderlineComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
